export default {
      id: "fruits-usage",
      viewBox: "0 0 37 28",
      url: __webpack_public_path__ + "img/icons.svg#fruits",
      toString: function () {
        return this.url;
      }
    }